/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InventoryControlSelectedItemModel { 
    itemNumber?: string | null;
    itemDescription?: string | null;
    itemClass?: string | null;
    weightType?: string | null;
    basedUOfM?: string | null;
    isScanItem?: boolean;
    isShelfLife?: boolean;
    isUniqueIdentifier?: boolean;
    isSiteController?: boolean;
}

